import React, { useEffect, useState } from 'react';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../services/api';
import * as analytics from '../services/analytics';
import Sidebar from './Sidebar';
import FloatingButton from './FloatingButton';

const Dashboard: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code) {
      api.post('/auth/exchange', { code }, { signal: controller.signal })
        .then(response => {
          const { token, userId, username, picture, subscriptionStatus, isAdmin } = response.data;
          localStorage.setItem('token', token);
          localStorage.setItem('userId', userId);
          localStorage.setItem('username', username);
          localStorage.setItem('picture', picture);
          localStorage.setItem('subscriptionStatus', subscriptionStatus || 'free');
          localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false');
          window.dispatchEvent(new Event('storage'));
          analytics.identify({ userId, name: username, subscriptionStatus, isAdmin });
          analytics.track('user_logged_in', { userId, subscriptionStatus, isAdmin });
          setAuthReady(true);
          navigate('/dashboard/home', { replace: true });
        })
        .catch(err => {
          if (!axios.isCancel(err)) {
            console.error("Error exchanging auth code:", err);
            navigate('/');
          }
        });
    } else {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/');
        return;
      }
      setAuthReady(true);
    }

    return () => {
      controller.abort();
    };
  }, [location.search, navigate]);

  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 text-sm">Authenticating...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex bg-gradient-to-br from-gray-50 to-primary-50/30">
      <Sidebar />
      <div className="flex-1 p-4 md:p-6 md:ml-0">
        <Outlet />
        <FloatingButton />
      </div>
    </div>
  );
};

export default Dashboard;
